$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var $body = $('body');

	// スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		$('body').prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			$body.addClass("scroll");
		} else {
			$body.removeClass("scroll");
		}
	});

	//プランスライドショー
  	var plan_swiper;
  	var isInitialized = false;
  	function initSwiper() {
	    if (window.innerWidth < 768 && !isInitialized) {
	      	plan_swiper = new Swiper('.plan_swiper', {
	      		loop: true,
	      		slidesPerView: "auto",
	      		spaceBetween: 0,
	      		centeredSlides: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},

	      	});
	      	isInitialized = true;
	   } else if (window.innerWidth >= 768 && isInitialized) {
      		plan_swiper.destroy(true, true);
      		plan_swiper = undefined;
      		isInitialized = false;
    	}
  	}
  	initSwiper();
  	$(window).on('resize', function() {
		initSwiper();
  	});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//開閉用ボタンをクリックでクラスの切替え
	// $('.header_btn').on('click', function () {
	// 	$body.toggleClass('open');
	// 	$subsidy.toggleClass('open');
	// 	return false;
	// });

	//ヘッダースクロール表示非表示
	// var startPos = 0,winScrollTop = 0;
	// $(window).on('scroll',function(){
	// 	winScrollTop = $(this).scrollTop();
	// 	if (winScrollTop >= startPos) {
	// 		$('.header').addClass('hide');
	// 	} else {
	// 		$('.header').removeClass('hide');
	// 	}
	// 	startPos = winScrollTop;
	// });

	//ヘッダードロップダウンメニュー
	// $('.submenu_btn').on('click', function () {
	// 	$(".layer").toggleClass('on');
	// 	$(this).toggleClass('on');
	// 	$(this).next(".submenu_wrap").toggleClass('on');
	// 	$(".submenu_btn").not(this).removeClass("on");
	// 	$(".submenu_btn").not(this).next().removeClass("on");
	// 	$(".submenu_btn").not(this).next().slideUp(300);
	// 	$(this).next().slideToggle(300);
	// });

	//ページトップボタンフッター前で止める
	// $(document).ready(function () {
	// 	$(window).on("scroll", function () {
	// 		scrollHeight = $(document).height();
	// 		scrollPosition = $(window).height() + $(window).scrollTop();
	// 		footHeight = $(".footer").innerHeight();
	// 		if (scrollHeight - scrollPosition <= footHeight) {
	// 			$(".fix_cv").addClass("fix_off");
	// 		} else {
	// 			$(".fix_cv").removeClass("fix_off");
	// 		}
	// 	});
	// });

	//アコーディオン
	// $(".acd_content").hide();
	// $(".acd_head").on("click", function() {
	// 	if($(this).hasClass('open')){
	// 		$(this).removeClass("open");
	// 		$(".acd_content").slideUp();
	// 	} else {
	// 		$(".acd_content").slideUp();
	// 		$(".acd_head").removeClass("open");
	// 		$(this).addClass("open");
	// 		$(this).next().slideToggle();
	// 	}
	// });

	//タイマー設定
	$(".view_timer").each(function(index, target) {
		var startDate = $(this).attr("data-start-date");
		var endDate = $(this).attr("data-end-date");
		var nowDate = new Date();
		if (startDate) {
			startDate = new Date(startDate);
		} else {
			startDate = nowDate;
		}
		if (endDate) {
			endDate = new Date(endDate);
		}
		if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
			$(this).show();
		} else {
			$(this).hide();
		}
	 });

});